module.exports = __webpack_public_path__ + "static/media/animacja.a287364.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animacja.webm
// module id = hP7w
// module chunks = 0